import React from 'react';
import { FormPassportContainer, FormPassportField } from '../../styles';
import { Caption2 } from '../../../../../../components/Font';
import { InputElement } from '../../../../../../ui/Input/Input';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { IRegisterForm } from '../../../../../../interface/Auth/frontend';

interface IProps {
	registerForm: IRegisterForm;
	setRegisterForm(value: IRegisterForm): void;
}

export const ForeignPassportBlock: React.FC<IProps> = ({ registerForm, setRegisterForm }) => {
	const { t } = useTranslation();
	const Theme = useTheme();

	return (
		<FormPassportContainer>
			<FormPassportField style={{ width: '100%' }}>
				<Caption2 color={Theme.color.secondary}>{t('auth.documentNumber')}</Caption2>
				<InputElement
					value={registerForm.passportNumber}
					onChange={value => setRegisterForm({ ...registerForm, passportNumber: value })}
				/>
			</FormPassportField>
		</FormPassportContainer>
	);
};
